export default __webpack_public_path__ + "static/img1-afa3a34e0b0d00024c628f76ca00020a.jpg";